import { render, staticRenderFns } from "./msgs_list.vue?vue&type=template&id=2f081374"
import script from "./msgs_list.vue?vue&type=script&lang=js"
export * from "./msgs_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports